// extracted by mini-css-extract-plugin
module.exports = {"meta":"PostMeta_meta__2FK4O","category":"PostMeta_category__3lGxg","tags":"PostMeta_tags__3moLD"};